// IE 2026 09 28 / ODOO-342342 (слово Игоря 28.09, вариант A разбора guide_vs_launchpad_2026-09-28.md): переход на стол и страницу из строки
// меню страницы — ссылки «Путеводитель» ↔ Launchpad. Бэк (workspaces.help_page_links → attrs.prepare_pagesTree) кладёт в меню страницы
// строку с командой workspace_goto и goto {workspace, page}; на «Путеводителе» ссылка на Launchpad — только администраторам (решает бэк).
// Маршрут — как у пункта списка столов (store.workspace_route_to: база, историческая модель), страница — параметром page.
// store.workspace_route_to(ws, page) с page читает WORKSPACES[ws].PAGES — стола, который ещё не открывали, там нет (TypeError), поэтому
// страница добавляется здесь. Фронт без этого модуля команду не знает и клик ничего не делает — бэк без правки фронта безвреден.

// маршрут перехода ('' — перейти нельзя: нет стола в goto или у store нет построителя маршрута)
export function workspaceGoto_to(store, goto) {
    const ws = goto && typeof goto.workspace === 'string' ? goto.workspace.trim() : ''
    if (!ws || !store || typeof store.workspace_route_to !== 'function') return ''
    let to = store.workspace_route_to(ws)
    if (typeof to !== 'string' || !to) return ''
    const page = goto && typeof goto.page === 'string' ? goto.page.trim() : ''
    if (page) to += `${to.includes('?') ? '&' : '?'}page=${encodeURIComponent(page)}`
    return to
}

// команда workspace_goto: true — переход запущен (router.push; стол и страницу открывает обычный обработчик маршрута), false — нет
export function workspaceGoto(store, action) {
    const to = workspaceGoto_to(store, action && action.goto)
    if (!to || !store.router || typeof store.router.push !== 'function') return false
    store.router.push(to)
    return true
}
